import { isIntentionalUserError } from "./error-tracking-config";

type CaughtErrorSink = (error: unknown, boundary: string) => void;

// Set once PostHog is up. No PostHog import here: global-error would ship it to every website page.
let sink: CaughtErrorSink | null = null;

export function setCaughtErrorSink(next: CaughtErrorSink): void {
  sink = next;
}

/** Error boundaries swallow errors before autocapture sees them; report explicitly. */
export function reportCaughtError(error: unknown, boundary: string): void {
  if (sink === null || isIntentionalUserError(error)) return;
  sink(error, boundary);
}
